// NOTE DO NOT USE THIS HOOK. USE YUP, INSTEAD.
// TODO: REFACTOR ANYTHING USING THIS TO USE YUP.
// TODO: REMOVE THIS HOOK.

import { useEffect, useState } from "react";
import validate from "validate.js";

import { DefaultFormState } from "@ds-developer/models";
import { defaultFormState } from "@ds-developer/constants";
import { format, isDate, parse } from "date-fns";

validate.extend(validate.validators.datetime, {
  parse: function (value: string | number | Date) {
    if (isDate(value)) {
      return value as Date;
    }
    if (typeof value === "number") {
      return new Date(value as number);
    }

    return parse(value as string, "yyyy-MM-DD HH:mm:ss", new Date());
  },

  format: function (
    value: string | number | Date,
    options: { dateOnly?: boolean },
  ) {
    const formatString = options.dateOnly
      ? "yyyy-MM-dd"
      : "yyyy-MM-dd HH:mm:ss";

    if (isDate(value)) {
      return format(value as Date, formatString);
    }

    return format(
      parse(value as string, "yyyy-MM-dd HH:mm:ss", new Date()),
      formatString,
    );
  },
});

type FormValidation<T> = {
  formState: T;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  setFormState: React.Dispatch<React.SetStateAction<T>>;
  reset: () => void;
};

const useFormValidation = <T extends DefaultFormState>({
  initialFormState = defaultFormState as T,
  schema,
}: {
  initialFormState?: T;
  schema: { [key: string]: any };
}): FormValidation<T> => {
  const [formState, setFormState] = useState<T>(initialFormState);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.persist();

    setFormState(formState => ({
      ...formState,
      values: {
        ...formState.values,
        [event.target.name]:
          event.target.type === "checkbox"
            ? event.target.checked
            : event.target.value,
      },
      touched: {
        ...formState.touched,
        [event.target.name]: true,
      },
    }));
  };

  const revalidateForm = () => {
    const errors = validate(formState.values, schema);

    setFormState((formState: any) => ({
      ...formState,
      isValid: errors ? false : true,
      errors: errors || {},
    }));
  };
  useEffect(revalidateForm, [formState.values]);

  const reset = () => {
    setFormState(initialFormState);
  };

  return {
    handleChange,
    formState,
    setFormState,
    reset,
  };
};

export default useFormValidation;
